import { FunctionComponent } from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend } from 'recharts';

const chartData = [
    { name: 'VIP', value: 38, color: '#21539B' },
    { name: 'Managers', value: 58, color: '#A0D5FF' },
    { name: 'Fraudsters', value: 24, color: '#218FE6' },
    { name: 'Shoplifters', value: 44, color: '#6C819F' },
];

const COLORS = ['#21539B', '#A0D5FF', '#218FE6', '#6C819F'];
const RADIAN = Math.PI / 180;


type CircleLegendProps = {
    label: string,
    color: string,
    value: string
}

const CircleLegend: FunctionComponent<CircleLegendProps> = ({ label, color }) => {
    return (
        <Stack direction="row" sx={{
            padding: '4px 10px 4px 10px',
        }}>
            <Box sx={{
                width: 24,
                borderRadius: '50%',
                height: 20,
                backgroundColor: color,
                padding: '0 0 0 0',
            }}>&nbsp;
            </Box>
            <Box sx={{
                display: 'flex',
                justifyContent: 'space-between',
                width: '100%'
            }}>
                <Typography sx={{
                    padding: '0px 10px 10px 15px',
                    color: 'grey.800',
                }}>
                    {label}
                </Typography>

            </Box>
        </Stack>
    )
}


const renderCustomizedLabel = (data: { cx: number, cy: number, midAngle: number, innerRadius: number, outerRadius: number, percent: number, index: number }) => {

    const radius = data.innerRadius + (data.outerRadius - data.innerRadius) * 0.5;
    const x = data.cx + radius * Math.cos(-data.midAngle * RADIAN);
    const y = data.cy + radius * Math.sin(-data.midAngle * RADIAN);

    return (
        <text x={x} y={y} fill="white" textAnchor='middle' dominantBaseline="central" fontSize={11} >
            {`${(data.percent * 100).toFixed(0)}%`}
        </text>
    );
};


export default function EventsByGroupPieChart() {

    const renderLegend = (props: any) => {
        const { payload } = props;
        
        return (
            <Box sx={{ mt: 2 }}>
                {
                    payload.map((entry: any, i: number) => {
                        const { payload: item } = entry;
                        return (
                            <CircleLegend key={i} label={item.name} color={item.color} value={item.value} />
                        )
                    })
                }
            </Box>
        )
    }


    return (
        <ResponsiveContainer >
            <PieChart  >
                <Pie
                    data={chartData}
                    labelLine={false}
                    innerRadius={45}
                    outerRadius={120}
                    cx={120}
                    dataKey="value"
                    label={renderCustomizedLabel}
                >
                    {chartData.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                    ))}
                </Pie>
                <Legend content={renderLegend} layout="vertical" verticalAlign="middle" align="right" />
            </PieChart>
        </ResponsiveContainer>
    );
}